export const organizationIdForUserCableEvent = data =>
    data?.activity?.organization_id ?? data?.organization_id ?? data?.asset?.organization_id

export const dispatchScopedUserCableEvent = ({
    data,
    currentOrganizationId,
    receiveCableEvent,
    invalidate,
}) => {
    const eventOrganizationId = organizationIdForUserCableEvent(data)
    if (String(eventOrganizationId) !== String(currentOrganizationId)) return false

    receiveCableEvent(data)
    invalidate(data)
    return true
}
